import format from "date-fns/format"
import { enUS } from "date-fns/locale"

export const dateTimeFormat = (dateTime?: string | null, timeFormat = "MMM d, yyyy hh:mm aa") => {
  return dateTime ? format(new Date(dateTime), timeFormat, { locale: enUS }) : null
}
